import { createSlice } from "@reduxjs/toolkit";
export const notificationStatusSlice = createSlice({
    name: "notificationStatus",
    initialState: {
        value: false,
    },
    reducers: {
        setNotificationStatus: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setNotificationStatus } = notificationStatusSlice.actions;
export default notificationStatusSlice.reducer;
